import { CanceledError } from "axios";
import { createWriteRequestLockAdapter } from "@supplier/utils";

import type { InternalAxiosRequestConfig } from "axios";
import type { WriteRequestLockAdapterOptions, WriteRequestLockHandle } from "@supplier/utils";

/**
 * Axios 内部配置附加的防重选项与当前请求锁句柄。
 */
export interface ConsoleAxiosWriteRequestConfig extends InternalAxiosRequestConfig {
    dedupe?: boolean;
    dedupeKey?: string;
    writeRequestLockHandle?: WriteRequestLockHandle;
}

/**
 * 重复写请求使用的稳定错误标识，供业务错误拦截器静默识别。
 */
export const DUPLICATE_WRITE_REQUEST_MESSAGE = "DUPLICATE_WRITE_REQUEST";

/**
 * 创建重复请求专用 Axios 取消错误，并保留原请求配置供响应拦截器识别。
 */
const createDuplicateWriteRequestError = (config: ConsoleAxiosWriteRequestConfig) => {
    const error = new CanceledError<unknown>(DUPLICATE_WRITE_REQUEST_MESSAGE);
    error.config = config;
    return error;
};

/**
 * 创建 Console Axios 薄封装，通用锁行为由共享适配器统一维护。
 */
export const createConsoleAxiosWriteRequestLock = (
    options: Omit<WriteRequestLockAdapterOptions<ConsoleAxiosWriteRequestConfig>, "createDuplicateError">
) => {
    return createWriteRequestLockAdapter({
        ...options,
        createDuplicateError: createDuplicateWriteRequestError
    });
};
